// extracted by mini-css-extract-plugin
export default {"backdrop":"KycModal_backdrop__YPfYL","modal":"KycModal_modal__gzmZ1","closeBtn":"KycModal_closeBtn__uwi2N","sdk":"KycModal_sdk__mVsT1","message":"KycModal_message__DE0WN"};